import type { WidgetProps } from './registry';
import { decodeWidgetData } from './decode-widget-data';

type Template = { name: string; kind?: string; summary?: string };

export function TemplatesList(props: WidgetProps) {
  const templates = (decodeWidgetData(props.payload).templates ?? []) as Template[];

  if (templates.length === 0) {
    return <p className="text-sm text-foreground-mute">No templates configured.</p>;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
      {templates.map((t) => (
        <div key={t.name} className="rounded border border-border p-3">
          <p className="text-sm font-medium">{t.name}</p>
          {t.kind && <p className="text-[10px] uppercase tracking-wider text-foreground-mute">{t.kind}</p>}
          {t.summary && <p className="text-xs text-foreground-mute mt-1">{t.summary}</p>}
        </div>
      ))}
    </div>
  );
}
